import { render } from "./OnDemandAssessmentInProgressPage.vue?vue&type=template&id=0f1c5bd5&scoped=true"
import script from "./OnDemandAssessmentInProgressPage.vue?vue&type=script&lang=js"
export * from "./OnDemandAssessmentInProgressPage.vue?vue&type=script&lang=js"

import "./OnDemandAssessmentInProgressPage.vue?vue&type=style&index=0&id=0f1c5bd5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1c5bd5"]])

export default __exports__